
// @ts-nocheck
import locale_de_45DE_46ts_099b300c from "#nuxt-i18n/099b300c";
import locale_fr_45CH_46ts_546d2414 from "#nuxt-i18n/546d2414";

export const localeCodes =  [
  "de-DE",
  "fr-CH"
]

export const localeLoaders = {
  "de-DE": [
    {
      key: "locale_de_45DE_46ts_099b300c",
      load: () => Promise.resolve(locale_de_45DE_46ts_099b300c),
      cache: false
    }
  ],
  "fr-CH": [
    {
      key: "locale_fr_45CH_46ts_546d2414",
      load: () => Promise.resolve(locale_fr_45CH_46ts_546d2414),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/cd50fe89" /* webpackChunkName: "config_config_46ts_cd50fe89" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de-DE",
      language: "de-DE",
      localId: "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
      files: [
        {
          path: "/vercel/path0/i18n/src/langs/de-DE.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "fr-CH",
      language: "fr-CH",
      localId: "018d5a8d5436739e983d042abe94d337",
      files: [
        {
          path: "/vercel/path0/i18n/src/langs/fr-CH.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de-DE",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "./src/langs/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de-DE",
    language: "de-DE",
    localId: "2fbb5fe2e29a4d70aa5854ce7ce3e20b",
    files: [
      {
        path: "/vercel/path0/i18n/src/langs/de-DE.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "fr-CH",
    language: "fr-CH",
    localId: "018d5a8d5436739e983d042abe94d337",
    files: [
      {
        path: "/vercel/path0/i18n/src/langs/fr-CH.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/